import { useState, useEffect } from "react";
import api from "../api";

const API = process.env.REACT_APP_API_URL;


function Conveyance() {

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [editingRow, setEditingRow] = useState(null);

  const [newRoute, setNewRoute] = useState({
    RouteNo: "",
    RouteName: "",
    RouteFare: ""
  });

  const fetchData = () => {

    api.get(`${API}/conveyance`)

      .then(res => {
        setData(res.data);

        // AUTO ROUTE NO
        const maxRoute = Math.max(...res.data.map(r => r.routeno), 0);
        setNewRoute(prev => ({ ...prev, RouteNo: maxRoute + 1 }));
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  // SEARCH
  const filtered = data.filter(r =>
    r.routename.toLowerCase().includes(search.toLowerCase()) ||
    String(r.routeno).includes(search)
  );

  // ADD
  const handleAdd = () => {
    if (!newRoute.RouteName) {
      alert("Enter route name");
      return;
    }


    api.post(`${API}/add-route`, newRoute)

      .then(() => {
        alert("Route Added");
        setNewRoute({ RouteNo: "", RouteName: "", RouteFare: "" });
        fetchData();
      });
  };

  // UPDATE
  const handleUpdate = (row) => {

    api.post(`${API}/update-route`, row)

      .then(() => {
        alert("Updated");
        setEditingRow(null);
        fetchData();
      });
  };

  // DELETE
  const handleDelete = (routeNo) => {
    if (!window.confirm("Delete this route?")) return;


    api.post(`${API}/delete-route`, { RouteNo: routeNo })

      .then(() => {
        alert("Deleted");
        fetchData();
      });
  };

  return (
    <div style={container}>

      <h2>Conveyance / Routes</h2>

      {/* SEARCH */}
      <input
        placeholder="Search Route..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={searchBox}
      />

      {/* ADD */}
      <div style={addBox}>
        <input value={newRoute.RouteNo} readOnly style={inputDisabled} />

        <input
          placeholder="Route Name"
          value={newRoute.RouteName}
          onChange={e => setNewRoute({ ...newRoute, RouteName: e.target.value })}
          style={input}
        />

        <input
          placeholder="Fare"
          value={newRoute.RouteFare}
          onChange={e => setNewRoute({ ...newRoute, RouteFare: e.target.value })}
          style={input}
        />

        <button onClick={handleAdd} style={addBtn}>
          + Add
        </button>
      </div>

      {/* TABLE */}
      <div style={card}>
        <table style={table}>
          <thead>
            <tr>
              <th style={{ ...cell, width: "15%" }}>Route No</th>
              <th style={{ ...cell, width: "35%" }}>Name</th>
              <th style={{ ...cell, width: "25%" }}>Fare</th>
              <th style={{ ...cell, width: "25%" }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((row, i) => {

              const isEditing = editingRow === row.routeno;

              return (
                <tr
                  key={i}
                  onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                  onMouseLeave={(e) => e.currentTarget.style.background = ""}
                >
                  <td style={cell}>{row.routeno}</td>

                  <td style={cell}>
                    <input
                      value={row.routename}
                      disabled={!isEditing}
                      style={isEditing ? input : inputDisabled}
                      onChange={(e) => {
                        const updated = [...data];
                        updated[i].routename = e.target.value;
                        setData(updated);
                      }}
                    />
                  </td>

                  <td style={cell}>
                    <input
                      value={row.routefare}
                      disabled={!isEditing}
                      style={isEditing ? input : inputDisabled}
                      onChange={(e) => {
                        const updated = [...data];
                        updated[i].routefare = e.target.value;
                        setData(updated);
                      }}
                    />
                  </td>

                  <td style={cell}>
                    {!isEditing ? (
                      <>
                        <button
                          onClick={() => setEditingRow(row.routeno)}
                          style={editBtn}
                        >
                          Edit
                        </button>

                        <button
                          onClick={() => handleDelete(row.routeno)}
                          style={deleteBtn}
                        >
                          Delete
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => handleUpdate(row)}
                          style={saveBtn}
                        >
                          Save
                        </button>

                        <button
                          onClick={() => {
                            setEditingRow(null);
                            fetchData();
                          }}
                          style={cancelBtn}
                        >
                          Cancel
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

    </div>
  );
}

/* STYLES */

const container = {
  padding: "30px",
  maxWidth: "1000px",
  margin: "auto"
};

const searchBox = {
  padding: "8px",
  width: "300px",
  marginBottom: "15px",
  borderRadius: "6px",
  border: "1px solid #ccc"
};

const addBox = {
  display: "flex",
  gap: "10px",
  marginBottom: "20px",
  background: "#fff",
  padding: "15px",
  borderRadius: "10px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
};

const input = {
  padding: "8px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  width: "90%",
  textAlign: "center",
  boxSizing: "border-box"   // ⭐ IMPORTANT FIX
};

const inputDisabled = {
  ...input,
  background: "#f1f5f9"
};

const addBtn = {
  background: "#2563eb",
  color: "#fff",
  border: "none",
  padding: "8px 15px",
  borderRadius: "6px",
  cursor: "pointer"
};

const editBtn = {
  background: "#f59e0b",
  color: "#fff",
  border: "none",
  padding: "6px 12px",
  borderRadius: "5px",
  marginRight: "5px",
  cursor: "pointer"
};

const saveBtn = {
  background: "#16a34a",
  color: "#fff",
  border: "none",
  padding: "6px 12px",
  borderRadius: "5px",
  marginRight: "5px",
  cursor: "pointer"
};

const cancelBtn = {
  background: "#6b7280",
  color: "#fff",
  border: "none",
  padding: "6px 12px",
  borderRadius: "5px",
  cursor: "pointer"
};

const deleteBtn = {
  background: "#dc2626",
  color: "#fff",
  border: "none",
  padding: "6px 12px",
  borderRadius: "5px",
  cursor: "pointer"
};

const card = {
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
};

const table = {
  width: "100%",
  borderCollapse: "separate",
  borderSpacing: "0 8px",
  tableLayout: "fixed"
};

const cell = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "center",
  background: "#fff"
};

export default Conveyance;